import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { InstrumentVM } from '../../../shared/viewmodels/ISearchService';

@Component({
  selector: 'app-property-search-doc-detail',
  templateUrl: './property-search-doc-detail.component.html',
  styleUrls: ['./property-search-doc-detail.component.css']
})
export class PropertySearchDocDetailComponent implements OnInit {

  @Input() recDocVM: any;
  @Input() loadingVisible: boolean = true;
  @Output() moveToRef = new EventEmitter<InstrumentVM>();
  @Input() book: string;
  @Input() page: string;
  @Input() isImgVwVisible: boolean;

  constructor() {
    console.log("info cons");

    //this.referrences[0].items = this.recDocVM.docRefTo;
    //this.referrences[1].items = this.recDocVM.docRefBy;

  }

  ngOnInit() {
    // console.log("detail info"+this.recDocVM.docID);
  }

  ItemClick(e) {
    if (e === null) {
      console.log('ItemClick fired and event is null');
    }
    else {
      console.log(`ItemClick fired: ${e.itemData}`);
      let payload = e.itemData as InstrumentVM;
      console.log(`primaryID: ${payload.primaryID}`);
      console.log(`secondaryID: ${payload.secondaryID}`);
      this.moveToRef.emit(payload);
    }
  }

}
